// Native browser WebSocket constructor reference.
//
// Why this lives in a shared helper: @supabase/realtime-js v2's
// WebSocketFactory.detectEnvironment() reads `globalThis.process.versions.node`
// to decide whether it's running in Node. Parcel polyfills `process` with
// `{ versions: { node: '...' } }` for legacy CJS compatibility, so realtime
// mis-detects the runtime as Node and throws "Node.js 20 detected without
// native WebSocket support". Passing `transport: BROWSER_WEB_SOCKET` to
// supabase's createClient skips the detection path entirely.
//
// SSR/test paths where neither `globalThis.WebSocket` nor `window.WebSocket`
// are available get `null` here — callers should spread `{ realtime:
// { transport: browserWebSocket() } }` only when truthy so the supabase
// detection runs as before in Node contexts.
//
// A FUNCTION read at call time, not a module-level constant: the constant was
// evaluated wherever the module loaded — at frank's serialization, in Node,
// that is Node's own native WebSocket, which cannot be serialized — so the
// published createSupabaseClient referenced a name that did not exist
// (frank verify: [unresolvable-identifier] BROWSER_WEB_SOCKET, gazer). The
// browser's WebSocket is only knowable in the browser.
export function browserWebSocket () {
  return (
    (typeof globalThis !== 'undefined' && globalThis.WebSocket) ||
    (typeof window !== 'undefined' && window.WebSocket) ||
    null
  )
}
